<template>
  <div class="text-sm">
    <p class="mt-6">
      <b>2026.03.07</b> - Баланс ассортимента магазина; качество выпадающих предметов
    </p>
    <div class="ml-5 pb-4 text-violet-600">
      <div class="font-bold mt-2">Новые возможности</div>
      <ul class="ml-4 list-disc">
        <li>
          Добавлена вторая полка в магазин, увеличивающая общее количество доступных предметов с 7
          до 14
        </li>
        <li>Магазин теперь отслеживает и отображает, какие предметы распроданы</li>
      </ul>

      <div class="font-bold mt-2">Геймплей и балансировка</div>
      <ul class="ml-4 list-disc">
        <li>Снижены цены в магазине для большинства предметов</li>
        <li>
          Добавлен небольшой шанс того, что предметы из Пещер и наград PvP будут очень высокого
          качества
        </li>
        <li>Способность "Отравленное оружие" больше не может быть применена к врагам без оружия</li>
      </ul>

      <div class="font-bold mt-2">ИИ боя</div>
      <ul class="ml-4 list-disc">
        <li>
          Добавлен учёт Адреналина и Мистической концентрации при определении возможности
          использования способности
        </li>
        <li>
          Исправлена ошибка, из-за которой способность "Фумигация" не использовалась в некоторых
          ситуациях, когда должна была
        </li>
      </ul>

      <div class="font-bold mt-2">Исправления ошибок</div>
      <ul class="ml-4 list-disc">
        <li>Исправлено несколько ошибок на экране редактирования героя</li>
        <li>Исправлено срабатывание вампирического оружия при смерти цели</li>
      </ul>
    </div>
  </div>
</template>
